module.exports = __webpack_public_path__ + "static/media/0.fca13317.JPG";